import {SHOW_POPUP, HIDE_POPUP} from '@/store/mutation-types'

export default {
	computed: {
		hasPopup() {
			return this.$store.getters.hasPopup
		},
		getPopupAction() {
			return this.$store.getters.popupAction
		},
		getPopupMessage() {
			return this.$store.getters.popupMessage
		},
		getPopupType() {
			return this.$store.getters.popupType
		},
		getPopupId() {
			return this.$store.getters.popupId
		},
		getPopupSpecification() {
			return this.$store.getters.popupSpecification
		}
	},
	methods: {
		showPopup(id, type, action, specification, message) {
			this.$store.commit(SHOW_POPUP, {action: action, type: type, id: id, specification: specification, message: message})
		},
		setPopupData(data) {
			this.$store.commit(SHOW_POPUP, data)
		},
		hidePopup() {
			this.$store.commit(HIDE_POPUP)
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/mixins/popup.js